module.exports = __webpack_public_path__ + "static/media/icon-user.a832ebd0.svg";